export default __webpack_public_path__ + "static/media/p1a1.0f8f64e0.png";